import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "hot-sales-side-content" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "img" }
const _hoisted_5 = { class: "name" }

import { ConstantField } from '@/constant/ConstantField';
import { Api } from '@/http/Api';
import { ResponseCode } from '@/http/ResponseCode';
import { router } from '@/router';
import { Action } from '@/typeDefine/CommonTypes';
import { GetHotProductResponse } from '@/typeDefine/HttpResponseType';
import { UtilMethods } from '@/util/UtilMethods';
import { onMounted, ref, Ref } from 'vue';
import { useRoute } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'HotSalesSide',
  setup(__props) {

const hotProduct: Ref<GetHotProductResponse['data']['hotProduct']> = ref([])

onMounted(() => {
    requestHotProduct()
})

const requestHotProduct: Action = async () => {
    const response: GetHotProductResponse = await Api.instance.getHotProductList()

    UtilMethods.showMessageToast(response,false)

    if(response.code === ResponseCode.OK) {
        hotProduct.value = response.data.hotProduct
    }
}

const gotoDetails: Action<[number]> = (id: number) => {
    router.push({
        name: 'productDetails',
        params: {
            id,
        }
    })
}

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('products.hotSales')), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hotProduct.value, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "hot-sales-list pointer-cursor",
        key: item.id,
        onClick: ($event: any) => (gotoDetails(item.id))
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_image, {
            src: `${item.cover}`,
            fit: "cover",
            style: {"width":"87px","height":"87px"}
          }, null, 8, ["src"])
        ]),
        _createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1)
      ], 8, _hoisted_3))
    }), 128))
  ]))
}
}

})